/**
 * Nsection B13 Service
 * B.13.減排 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/nsection-b13';

export interface FormulaParameter {
  symbol: string;
  para_type?: number | null;
  scenarios: string;
  unit: string;
  annual_value: number | null;
}

export interface FormulaEntry {
  id: string;
  equation_note: string;
  equation: { latex: string };
  parameters: FormulaParameter[];
  calculation_result: { value: number | null; unit: string };
}

export interface NsectionB13Detail {
  id: number;
  organization_id: number;
  proposal_id: number;
  er_calculate: FormulaEntry[] | null;
  er_description: string | null;
  nsection_b13_pct: number;
  edit_by: number;
  created_at: string;
  updated_at: string | null;
}

export interface NsectionB13Update {
  er_calculate?: FormulaEntry[];
  er_description?: string;
}

export interface ParameterSummaryItem {
  source_section: string;
  source_label: string;
  equation_latex: string;
  symbol: string;
  para_type: number | null;
  scenarios: string | null;
  unit: string | null;
  annual_value: number | null;
}

const nsectionB13Service = {
  getByProposal: async (proposalId: number): Promise<NsectionB13Detail | null> => {
    const response = await axios.get(`${BASE_URL}/by-proposal/${proposalId}`);
    return response.data;
  },
  update: async (proposalId: number, data: NsectionB13Update): Promise<NsectionB13Detail> => {
    const response = await axios.put(`${BASE_URL}/${proposalId}`, data);
    return response.data;
  },
  getParametersSummary: async (proposalId: number): Promise<ParameterSummaryItem[]> => {
    const response = await axios.get(`${BASE_URL}/parameters-summary/${proposalId}`);
    return response.data;
  },
};

export default nsectionB13Service;
